
import api from '@/plugins/api'
import { Vue, Component } from 'vue-property-decorator'
import MenuModal from '@/modules/menu/MenuModal.vue'
import eventBus from '@/plugins/eventBus'
import { envConfiguration } from '@/plugins/globalStaticDatas'
import UserModule from '../headers/UserModule.vue'

@Component({
  components: { MenuModal, UserModule },
})
export default class DailyMenu extends Vue {
  dailyMenu: Object = {}
  alacarteMenu: Object = {}
  envConfigurations: any = envConfiguration
  isAfterNoon = false
  menuTitle = 'Menuja e ditës'
  feedbackLabel: string = 'Feedback'
  scy = 0
  scrollFunction() {
    this.scy = window.scrollY
  }
  topFunction() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }
  backTohome() {
    this.$router.push({ name: 'Home' })
  }

  mounted() {
    // window.addEventListener('scroll', this.scrollFunction)
    api()
      .get('daily-menu')
      .then((response: any) => {
        // this.dailyMenu = response.data.data
        // START OF DUMMY -----------------------------------------------------------------------
        // let dymmy = {
        //   message: 'Sukses',
        //   status: 0,
        //   data: {
        //     '0': {
        //       id: 113,
        //       order_position: 0,
        //       product_type: 'Tradite',
        //       products: [
        //         {
        //           id: 19870,
        //           name: 'Qofte shtepie shoqeruar me pure patate',
        //           description: 'Qofte shtepie me mish vici te grire, shoqeruar me pure patate',
        //           sale_price: 400,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 113,
        //           order_position: 0,
        //           product_type: 'Tradite',
        //           attributes: '',
        //           photo: '/uploads/products/19870/1619503185-785D868D-5BAB-4705-A644-A63D9FA50C77.jpeg',
        //           photos: [
        //             {
        //               id: 18086,
        //               name: '1619503185-785D868D-5BAB-4705-A644-A63D9FA50C77.jpeg',
        //               path: 'uploads/products/19870/1619503185-785D868D-5BAB-4705-A644-A63D9FA50C77.jpeg',
        //               thumbnail_path: 'uploads/products/19870/tn-1619503185-785D868D-5BAB-4705-A644-A63D9FA50C77.jpeg',
        //               imageable_id: 19870,
        //               imageable_type: 'App\\Product',
        //               created_at: '2021-04-27 07:59:45',
        //               updated_at: '2021-04-27 07:59:45',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 2529,
        //           name: 'Fergese Elbasani',
        //           description:
        //             'Speca, domate, gjize, hudher, majdanoz, kripe , piper, vaj ulliri (TRADITIONAL ALBANIAN COOCKED GREEN PEPPER, GARLIC, TOMATOES, COTTAGE CHEESE)',
        //           sale_price: 300,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 113,
        //           order_position: 0,
        //           product_type: 'Tradite',
        //           attributes: '',
        //           photo: '/uploads/products/2529/1571048051-ines-cilka_ferges-albania.jpg',
        //           photos: [
        //             {
        //               id: 12370,
        //               name: '1571048051-ines-cilka_ferges-albania.jpg',
        //               path: 'uploads/products/2529/1571048051-ines-cilka_ferges-albania.jpg',
        //               thumbnail_path: 'uploads/products/2529/tn-1571048051-ines-cilka_ferges-albania.jpg',
        //               imageable_id: 2529,
        //               imageable_type: 'App\\Product',
        //               created_at: '2019-10-14 12:14:11',
        //               updated_at: '2019-10-14 12:14:11',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 9842,
        //           name: 'Thjerreza me salcice',
        //           description: 'LENTILS WITH SAUSAGES',
        //           sale_price: 350,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 113,
        //           order_position: 0,
        //           product_type: 'Tradite',
        //           attributes: '',
        //           photo: '/uploads/products/9842/1575268605--1200-630-thjeee_salccc.jpg',
        //           photos: [
        //             {
        //               id: 13142,
        //               name: '1575268605--1200-630-thjeee_salccc.jpg',
        //               path: 'uploads/products/9842/1575268605--1200-630-thjeee_salccc.jpg',
        //               thumbnail_path: 'uploads/products/9842/tn-1575268605--1200-630-thjeee_salccc.jpg',
        //               imageable_id: 9842,
        //               imageable_type: 'App\\Product',
        //               created_at: '2019-12-02 07:36:45',
        //               updated_at: '2019-12-02 07:36:45',
        //               sector_ids: null,
        //             },
        //             {
        //               id: 17363,
        //               name: '1609397510-D2169A16-E008-4705-9F65-9C5285FDA90F.jpeg',
        //               path: 'uploads/products/9842/1609397510-D2169A16-E008-4705-9F65-9C5285FDA90F.jpeg',
        //               thumbnail_path: 'uploads/products/9842/tn-1609397510-D2169A16-E008-4705-9F65-9C5285FDA90F.jpeg',
        //               imageable_id: 9842,
        //               imageable_type: 'App\\Product',
        //               created_at: '2020-12-31 07:51:50',
        //               updated_at: '2020-12-31 07:51:50',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //       ],
        //     },
        //     '3': {
        //       id: 147,
        //       order_position: 1,
        //       product_type: 'Antipasta',
        //       products: [
        //         {
        //           id: 3500,
        //           name: 'Qofte me perime spanjolle',
        //           description: 'Qofte me perime te ndryshme. (CROQUETTE with VEGETABLES)',
        //           sale_price: 400,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 147,
        //           order_position: 1,
        //           product_type: 'Antipasta',
        //           attributes: '',
        //           photo: '/uploads/products/3500/1650008983-qofte spanjolle.png',
        //           photos: [
        //             {
        //               id: 19578,
        //               name: '1650008983-qofte spanjolle.png',
        //               path: 'uploads/products/3500/1650008983-qofte spanjolle.png',
        //               thumbnail_path: 'uploads/products/3500/tn-1650008983-qofte spanjolle.png',
        //               imageable_id: 3500,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-04-15 09:49:43',
        //               updated_at: '2022-04-15 09:49:43',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 21304,
        //           name: 'Fokace kapreze',
        //           description: 'Fokace me brum pice me domate të freskët, mocarela & borzilok',
        //           sale_price: 450,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 147,
        //           order_position: 1,
        //           product_type: 'Antipasta',
        //           attributes: '',
        //           photo: '/uploads/products/21304/1650536357-FOKACE KAPREZE OK.jpg',
        //           photos: [
        //             {
        //               id: 19602,
        //               name: '1650536357-FOKACE KAPREZE OK.jpg',
        //               path: 'uploads/products/21304/1650536357-FOKACE KAPREZE OK.jpg',
        //               thumbnail_path: 'uploads/products/21304/tn-1650536357-FOKACE KAPREZE OK.jpg',
        //               imageable_id: 21304,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-04-21 12:19:17',
        //               updated_at: '2022-04-21 12:19:17',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 21303,
        //           name: 'Karkaleca në guackë',
        //           description: 'karkaleca të pjekur me pana dhe galetë të aromatizuar)',
        //           sale_price: 490,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 147,
        //           order_position: 1,
        //           product_type: 'Antipasta',
        //           attributes: '',
        //           photo: '/uploads/products/21303/1648752188-B221549C-88DD-42F7-BCC9-09D91DD5136E.jpeg',
        //           photos: [
        //             {
        //               id: 19530,
        //               name: '1648752188-B221549C-88DD-42F7-BCC9-09D91DD5136E.jpeg',
        //               path: 'uploads/products/21303/1648752188-B221549C-88DD-42F7-BCC9-09D91DD5136E.jpeg',
        //               thumbnail_path: 'uploads/products/21303/tn-1648752188-B221549C-88DD-42F7-BCC9-09D91DD5136E.jpeg',
        //               imageable_id: 21303,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-03-31 20:43:08',
        //               updated_at: '2022-03-31 20:43:08',
        //               sector_ids: null,
        //             },
        //             {
        //               id: 19573,
        //               name: '1650008683-karkaleca guacke.png',
        //               path: 'uploads/products/21303/1650008683-karkaleca guacke.png',
        //               thumbnail_path: 'uploads/products/21303/tn-1650008683-karkaleca guacke.png',
        //               imageable_id: 21303,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-04-15 09:44:43',
        //               updated_at: '2022-04-15 09:44:43',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 21140,
        //           name: 'Chicken wings',
        //           description: '(Krahë pule të skuqura shoqëruar me salcë sweet&sour',
        //           sale_price: 400,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 147,
        //           order_position: 1,
        //           product_type: 'Antipasta',
        //           attributes: '',
        //           photo: '/uploads/products/21140/1641840465_product_photos.jpeg',
        //           photos: [
        //             {
        //               id: 19387,
        //               name: '1641840465_product_photos.jpeg',
        //               path: 'uploads/products/21140/1641840465_product_photos.jpeg',
        //               thumbnail_path: 'uploads/products/21140/tn-1641840465_product_photos.jpeg',
        //               imageable_id: 21140,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-01-10 19:47:45',
        //               updated_at: '2022-01-10 19:47:45',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 21139,
        //           name: 'Karpacio oktapodi',
        //           description: 'Oktapod I gatuar me erëza i trajtuar karpacio marinuar me salcë limoni)',
        //           sale_price: 450,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 147,
        //           order_position: 1,
        //           product_type: 'Antipasta',
        //           attributes: '',
        //           photo: '/uploads/products/21139/1648752270-FC1D5662-03E4-43AF-BA9E-8E2AD62FF1CE.jpeg',
        //           photos: [
        //             {
        //               id: 19531,
        //               name: '1648752270-FC1D5662-03E4-43AF-BA9E-8E2AD62FF1CE.jpeg',
        //               path: 'uploads/products/21139/1648752270-FC1D5662-03E4-43AF-BA9E-8E2AD62FF1CE.jpeg',
        //               thumbnail_path: 'uploads/products/21139/tn-1648752270-FC1D5662-03E4-43AF-BA9E-8E2AD62FF1CE.jpeg',
        //               imageable_id: 21139,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-03-31 20:44:30',
        //               updated_at: '2022-03-31 20:44:30',
        //               sector_ids: null,
        //             },
        //             {
        //               id: 19574,
        //               name: '1650008724-karpacio oktapodi.jpg',
        //               path: 'uploads/products/21139/1650008724-karpacio oktapodi.jpg',
        //               thumbnail_path: 'uploads/products/21139/tn-1650008724-karpacio oktapodi.jpg',
        //               imageable_id: 21139,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-04-15 09:45:24',
        //               updated_at: '2022-04-15 09:45:24',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 8933,
        //           name: 'Kerpudha te mbushura me tartuf',
        //           description: 'Kërpudha të plota të mbushura me pana, kërpudha dhe salce tartufi',
        //           sale_price: 400,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 147,
        //           order_position: 1,
        //           product_type: 'Antipasta',
        //           attributes: '',
        //           photo: '/uploads/products/8933/1641841407-funghi-fb.jpg',
        //           photos: [
        //             {
        //               id: 19388,
        //               name: '1641841407-funghi-fb.jpg',
        //               path: 'uploads/products/8933/1641841407-funghi-fb.jpg',
        //               thumbnail_path: 'uploads/products/8933/tn-1641841407-funghi-fb.jpg',
        //               imageable_id: 8933,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-01-10 20:03:27',
        //               updated_at: '2022-01-10 20:03:27',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 2587,
        //           name: 'Antipaste Miks',
        //           description: 'Miks djathra dhe proshuta, recel & arra',
        //           sale_price: 900,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 147,
        //           order_position: 1,
        //           product_type: 'Antipasta',
        //           attributes: '',
        //           photo: '/uploads/products/2587/1650536058-ANTIPASTE MIKS OK.jpg',
        //           photos: [
        //             {
        //               id: 19601,
        //               name: '1650536058-ANTIPASTE MIKS OK.jpg',
        //               path: 'uploads/products/2587/1650536058-ANTIPASTE MIKS OK.jpg',
        //               thumbnail_path: 'uploads/products/2587/tn-1650536058-ANTIPASTE MIKS OK.jpg',
        //               imageable_id: 2587,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-04-21 12:14:18',
        //               updated_at: '2022-04-21 12:14:18',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //       ],
        //     },
        //     '4': {
        //       id: 100,
        //       order_position: 1,
        //       product_type: 'Menu e kombinuar - Business Lunch',
        //       products: [
        //         {
        //           id: 21704,
        //           name: 'Farfalle me salmon dhe asparag + Sallatë 5 color + Fruta',
        //           description: 'Farfalle me salmon dhe asparag + Sallatë 5 color + Fruta',
        //           sale_price: 780,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 100,
        //           order_position: 1,
        //           product_type: 'Menu e kombinuar - Business Lunch',
        //           attributes: '',
        //           photo:
        //             '/uploads/products/21704/1656318385-Creamy-Bowtie-Pasta-with-Salmond-and-Asparagus-foodiecrush.com-015.jpg',
        //           photos: [
        //             {
        //               id: 20033,
        //               name: '1656318385-Creamy-Bowtie-Pasta-with-Salmond-and-Asparagus-foodiecrush.com-015.jpg',
        //               path: 'uploads/products/21704/1656318385-Creamy-Bowtie-Pasta-with-Salmond-and-Asparagus-foodiecrush.com-015.jpg',
        //               thumbnail_path:
        //                 'uploads/products/21704/tn-1656318385-Creamy-Bowtie-Pasta-with-Salmond-and-Asparagus-foodiecrush.com-015.jpg',
        //               imageable_id: 21704,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-06-27 10:26:25',
        //               updated_at: '2022-06-27 10:26:25',
        //               sector_ids: null,
        //             },
        //             {
        //               id: 20034,
        //               name: '1656318578-414768.jpg',
        //               path: 'uploads/products/21704/1656318578-414768.jpg',
        //               thumbnail_path: 'uploads/products/21704/tn-1656318578-414768.jpg',
        //               imageable_id: 21704,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-06-27 10:29:38',
        //               updated_at: '2022-06-27 10:29:39',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 20093,
        //           name: 'Speca te mbushur + Tarator + Frut',
        //           description:
        //             'Speca te mbushur me mish te grire + Tarator + Frut —- Different peppers are stuffed with Ground Beef, tomatoes and rice + yoghurt with cucumber + fruits',
        //           sale_price: 580,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 100,
        //           order_position: 1,
        //           product_type: 'Menu e kombinuar - Business Lunch',
        //           attributes: '',
        //           photo: '/uploads/products/20093/1622440607-9AC3DEE9-7ED5-4D6E-9F64-467DDA41AFEB.jpeg',
        //           photos: [
        //             {
        //               id: 18319,
        //               name: '1622440607-9AC3DEE9-7ED5-4D6E-9F64-467DDA41AFEB.jpeg',
        //               path: 'uploads/products/20093/1622440607-9AC3DEE9-7ED5-4D6E-9F64-467DDA41AFEB.jpeg',
        //               thumbnail_path: 'uploads/products/20093/tn-1622440607-9AC3DEE9-7ED5-4D6E-9F64-467DDA41AFEB.jpeg',
        //               imageable_id: 20093,
        //               imageable_type: 'App\\Product',
        //               created_at: '2021-05-31 07:56:47',
        //               updated_at: '2021-05-31 07:56:47',
        //               sector_ids: null,
        //             },
        //             {
        //               id: 18320,
        //               name: '1622440634-2A0E7AFB-FF06-477F-B482-C3DD1E76AE1A.jpeg',
        //               path: 'uploads/products/20093/1622440634-2A0E7AFB-FF06-477F-B482-C3DD1E76AE1A.jpeg',
        //               thumbnail_path: 'uploads/products/20093/tn-1622440634-2A0E7AFB-FF06-477F-B482-C3DD1E76AE1A.jpeg',
        //               imageable_id: 20093,
        //               imageable_type: 'App\\Product',
        //               created_at: '2021-05-31 07:57:14',
        //               updated_at: '2021-05-31 07:57:14',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 21705,
        //           name: 'Thjerrëza me salcice + Sallatë greke + Fruta',
        //           description: 'Thjerrëza me salcice + Sallatë greke + Fruta',
        //           sale_price: 580,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 100,
        //           order_position: 1,
        //           product_type: 'Menu e kombinuar - Business Lunch',
        //           attributes: '',
        //           photo: '/uploads/products/21705/1656318713-Lentils+and+Sausage+Soup.jpg',
        //           photos: [
        //             {
        //               id: 20035,
        //               name: '1656318713-Lentils+and+Sausage+Soup.jpg',
        //               path: 'uploads/products/21705/1656318713-Lentils+and+Sausage+Soup.jpg',
        //               thumbnail_path: 'uploads/products/21705/tn-1656318713-Lentils+and+Sausage+Soup.jpg',
        //               imageable_id: 21705,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-06-27 10:31:53',
        //               updated_at: '2022-06-27 10:31:53',
        //               sector_ids: null,
        //             },
        //             {
        //               id: 20036,
        //               name: '1656318752-grek1.jpg',
        //               path: 'uploads/products/21705/1656318752-grek1.jpg',
        //               thumbnail_path: 'uploads/products/21705/tn-1656318752-grek1.jpg',
        //               imageable_id: 21705,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-06-27 10:32:32',
        //               updated_at: '2022-06-27 10:32:33',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //       ],
        //     },
        //     '13': {
        //       id: 148,
        //       order_position: 2,
        //       product_type: 'Sallata / Salads',
        //       products: [
        //         {
        //           id: 21345,
        //           name: 'Sallate Adriatik',
        //           description: 'Sallatë jeshile, radikio, ullinj, pomodorini, ton, misër',
        //           sale_price: 430,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 148,
        //           order_position: 2,
        //           product_type: 'Sallata / Salads',
        //           attributes: '',
        //           photo: '/uploads/products/21345/1650536597-ADRIATIK OK.jpg',
        //           photos: [
        //             {
        //               id: 19604,
        //               name: '1650536597-ADRIATIK OK.jpg',
        //               path: 'uploads/products/21345/1650536597-ADRIATIK OK.jpg',
        //               thumbnail_path: 'uploads/products/21345/tn-1650536597-ADRIATIK OK.jpg',
        //               imageable_id: 21345,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-04-21 12:23:17',
        //               updated_at: '2022-04-21 12:23:17',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 8299,
        //           name: 'New Sallate Fresh Garden',
        //           description: 'Spinaq, sallate jeshile, luleshtrydhe, gorgonxola, arre pekan, "sauce" luleshtrydhe.',
        //           sale_price: 430,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 148,
        //           order_position: 2,
        //           product_type: 'Sallata / Salads',
        //           attributes: '',
        //           photo: '/uploads/products/8299/1566981900-1 (51).jpg',
        //           photos: [
        //             {
        //               id: 11746,
        //               name: '1566981900-1 (51).jpg',
        //               path: 'uploads/products/8299/1566981900-1 (51).jpg',
        //               thumbnail_path: 'uploads/products/8299/tn-1566981900-1 (51).jpg',
        //               imageable_id: 8299,
        //               imageable_type: 'App\\Product',
        //               created_at: '2019-08-28 10:45:00',
        //               updated_at: '2019-08-28 10:45:00',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 2638,
        //           name: 'Sallate  greke',
        //           description:
        //             'Domate, sallate jeshile, ullinj, vaj, spec jeshil,,kastravec, kripe, rigon, djath (GREEK SALAD with OLIVE, CHEESE, GREEN PEPPER, etc)',
        //           sale_price: 350,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 148,
        //           order_position: 2,
        //           product_type: 'Sallata / Salads',
        //           attributes: '',
        //           photo: '/uploads/products/2638/1532783074-sallate greke.png',
        //           photos: [
        //             {
        //               id: 1450,
        //               name: '1532783074-sallate greke.png',
        //               path: 'uploads/products/2638/1532783074-sallate greke.png',
        //               thumbnail_path: 'uploads/products/2638/tn-1532783074-sallate greke.png',
        //               imageable_id: 2638,
        //               imageable_type: 'App\\Product',
        //               created_at: '2018-07-28 15:04:34',
        //               updated_at: '2018-07-28 15:04:35',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 9094,
        //           name: 'Sallate aziatike',
        //           description:
        //             'Flete karrote , kastravec, finok, qepe e njome, filiza soje, ", sauce" sekrete aziatike , fara susami.',
        //           sale_price: 350,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 148,
        //           order_position: 2,
        //           product_type: 'Sallata / Salads',
        //           attributes: '',
        //           photo: '/uploads/products/9094/1650536792-AZIATIKE OK.jpg',
        //           photos: [
        //             {
        //               id: 19605,
        //               name: '1650536792-AZIATIKE OK.jpg',
        //               path: 'uploads/products/9094/1650536792-AZIATIKE OK.jpg',
        //               thumbnail_path: 'uploads/products/9094/tn-1650536792-AZIATIKE OK.jpg',
        //               imageable_id: 9094,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-04-21 12:26:32',
        //               updated_at: '2022-04-21 12:26:32',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 21143,
        //           name: 'Sallata e jetes',
        //           description: 'Sallate jeshile, panxhar, kinoa, avokado,,djathe i bardhe',
        //           sale_price: 390,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 148,
        //           order_position: 2,
        //           product_type: 'Sallata / Salads',
        //           attributes: '',
        //           photo: '/uploads/products/21143/1650539341-sallata e jetes.JPG',
        //           photos: [
        //             {
        //               id: 19607,
        //               name: '1650539341-sallata e jetes.JPG',
        //               path: 'uploads/products/21143/1650539341-sallata e jetes.JPG',
        //               thumbnail_path: 'uploads/products/21143/tn-1650539341-sallata e jetes.JPG',
        //               imageable_id: 21143,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-04-21 13:09:01',
        //               updated_at: '2022-04-21 13:09:01',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 17672,
        //           name: 'Sallate Cezar  me bacon',
        //           description: 'Sallate Cezar - Cesar Salad',
        //           sale_price: 390,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 148,
        //           order_position: 2,
        //           product_type: 'Sallata / Salads',
        //           attributes: '',
        //           photo: '/uploads/products/17672/1592773331-caesar-salad-10.jpg',
        //           photos: [
        //             {
        //               id: 16022,
        //               name: '1592773331-caesar-salad-10.jpg',
        //               path: 'uploads/products/17672/1592773331-caesar-salad-10.jpg',
        //               thumbnail_path: 'uploads/products/17672/tn-1592773331-caesar-salad-10.jpg',
        //               imageable_id: 17672,
        //               imageable_type: 'App\\Product',
        //               created_at: '2020-06-21 23:02:11',
        //               updated_at: '2020-06-21 23:02:11',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //       ],
        //     },
        //     '19': {
        //       id: 50,
        //       order_position: 3,
        //       product_type: 'Pjate e Pare',
        //       products: [
        //         {
        //           id: 18695,
        //           name: 'Spageti me Kungull dhe Karkalec',
        //           description: 'karkaleca të tiganisur me kungull të shuar  me verë të bardhë, majdanoz)',
        //           sale_price: 550,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 50,
        //           order_position: 3,
        //           product_type: 'Pjate e Pare',
        //           attributes: '',
        //           photo: '/uploads/products/18695/1645002826-Garlic-Butter-Shrimp-Pasta-7.jpeg',
        //           photos: [
        //             {
        //               id: 19472,
        //               name: '1645002826-Garlic-Butter-Shrimp-Pasta-7.jpeg',
        //               path: 'uploads/products/18695/1645002826-Garlic-Butter-Shrimp-Pasta-7.jpeg',
        //               thumbnail_path: 'uploads/products/18695/tn-1645002826-Garlic-Butter-Shrimp-Pasta-7.jpeg',
        //               imageable_id: 18695,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-02-16 10:13:46',
        //               updated_at: '2022-02-16 10:13:47',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 2624,
        //           name: 'Rizoto me perime dhe pule',
        //           description:
        //             'Fileto pule,oriz, bizele,karrota,spec jeshil,qepe, vaj ulliri, kripe, spec i kuq (RISOTTO - RICE with CHICKEN and VEGETABLES)',
        //           sale_price: 480,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 50,
        //           order_position: 3,
        //           product_type: 'Pjate e Pare',
        //           attributes: '',
        //           photo: '/uploads/products/2624/1532602356-insalata-riso_THUMB.png',
        //           photos: [
        //             {
        //               id: 1258,
        //               name: '1532602356-insalata-riso_THUMB.png',
        //               path: 'uploads/products/2624/1532602356-insalata-riso_THUMB.png',
        //               thumbnail_path: 'uploads/products/2624/tn-1532602356-insalata-riso_THUMB.png',
        //               imageable_id: 2624,
        //               imageable_type: 'App\\Product',
        //               created_at: '2018-07-26 12:52:36',
        //               updated_at: '2018-07-26 12:52:37',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 21346,
        //           name: 'Rizoto Zafferano & ragu di mare',
        //           description: 'Rizoto me shafran dhe karkaleca në salcë “bisque”',
        //           sale_price: 590,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 50,
        //           order_position: 3,
        //           product_type: 'Pjate e Pare',
        //           attributes: '',
        //           photo: '/uploads/products/21346/1650009070-riroto zafferano.png',
        //           photos: [
        //             {
        //               id: 19579,
        //               name: '1650009070-riroto zafferano.png',
        //               path: 'uploads/products/21346/1650009070-riroto zafferano.png',
        //               thumbnail_path: 'uploads/products/21346/tn-1650009070-riroto zafferano.png',
        //               imageable_id: 21346,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-04-15 09:51:10',
        //               updated_at: '2022-04-15 09:51:10',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 21155,
        //           name: 'Pene Rusticcante',
        //           description: 'Pene arrabiata dhe salsice pikante.',
        //           sale_price: 450,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 50,
        //           order_position: 3,
        //           product_type: 'Pjate e Pare',
        //           attributes: '',
        //           photo: '/uploads/products/21155/1641892131-penne-alla-rusticana.jpg',
        //           photos: [
        //             {
        //               id: 19396,
        //               name: '1641892131-penne-alla-rusticana.jpg',
        //               path: 'uploads/products/21155/1641892131-penne-alla-rusticana.jpg',
        //               thumbnail_path: 'uploads/products/21155/tn-1641892131-penne-alla-rusticana.jpg',
        //               imageable_id: 21155,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-01-11 10:08:51',
        //               updated_at: '2022-01-11 10:08:52',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 19128,
        //           name: 'Rizoto nero kerpudhe dhe salce tartufi',
        //           description: 'Rizoto nero me kerpudha, salce tartufi dhe krem grana.',
        //           sale_price: 480,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 50,
        //           order_position: 3,
        //           product_type: 'Pjate e Pare',
        //           attributes: '',
        //           photo: '/uploads/products/19128/1608535627-WhatsApp Image 2020-12-21 at 2.06.17 AM.jpeg',
        //           photos: [
        //             {
        //               id: 17309,
        //               name: '1608535627-WhatsApp Image 2020-12-21 at 2.06.17 AM.jpeg',
        //               path: 'uploads/products/19128/1608535627-WhatsApp Image 2020-12-21 at 2.06.17 AM.jpeg',
        //               thumbnail_path:
        //                 'uploads/products/19128/tn-1608535627-WhatsApp Image 2020-12-21 at 2.06.17 AM.jpeg',
        //               imageable_id: 19128,
        //               imageable_type: 'App\\Product',
        //               created_at: '2020-12-21 08:27:07',
        //               updated_at: '2020-12-21 08:27:07',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 21298,
        //           name: 'Rizoto Trevisano',
        //           description:
        //             'Rizoto trevisano - kerpudha , pecorino, biftek julienne, radikio, sherebele, demiglass vici.',
        //           sale_price: 590,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 50,
        //           order_position: 3,
        //           product_type: 'Pjate e Pare',
        //           attributes: '',
        //           photo: '/uploads/products/21298/1648752460-5ADFF3C4-1219-433A-B09F-8C0DD3F416F0.jpeg',
        //           photos: [
        //             {
        //               id: 19532,
        //               name: '1648752460-5ADFF3C4-1219-433A-B09F-8C0DD3F416F0.jpeg',
        //               path: 'uploads/products/21298/1648752460-5ADFF3C4-1219-433A-B09F-8C0DD3F416F0.jpeg',
        //               thumbnail_path: 'uploads/products/21298/tn-1648752460-5ADFF3C4-1219-433A-B09F-8C0DD3F416F0.jpeg',
        //               imageable_id: 21298,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-03-31 20:47:40',
        //               updated_at: '2022-03-31 20:47:40',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 21261,
        //           name: 'Ravioli Caprese',
        //           description: 'Ravioli të mbushur me krem pesto, në salcë  pomodorini dhe mocarela të freskët)',
        //           sale_price: 490,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 50,
        //           order_position: 3,
        //           product_type: 'Pjate e Pare',
        //           attributes: '',
        //           photo: '/uploads/products/21261/1646901919-WhatsApp Image 2022-03-10 at 9.44.24 AM.jpeg',
        //           photos: [
        //             {
        //               id: 19492,
        //               name: '1646901919-WhatsApp Image 2022-03-10 at 9.44.24 AM.jpeg',
        //               path: 'uploads/products/21261/1646901919-WhatsApp Image 2022-03-10 at 9.44.24 AM.jpeg',
        //               thumbnail_path:
        //                 'uploads/products/21261/tn-1646901919-WhatsApp Image 2022-03-10 at 9.44.24 AM.jpeg',
        //               imageable_id: 21261,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-03-10 09:45:19',
        //               updated_at: '2022-03-10 09:45:19',
        //               sector_ids: null,
        //             },
        //             {
        //               id: 19493,
        //               name: '1646901923-caprese-ravioli1.jpeg',
        //               path: 'uploads/products/21261/1646901923-caprese-ravioli1.jpeg',
        //               thumbnail_path: 'uploads/products/21261/tn-1646901923-caprese-ravioli1.jpeg',
        //               imageable_id: 21261,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-03-10 09:45:23',
        //               updated_at: '2022-03-10 09:45:23',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 5610,
        //           name: 'Spageti Carbonara Romana',
        //           description: 'Spageti te fresketa, pancete e tymosur, te kuq veze dhe pecorino romano.',
        //           sale_price: 450,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 50,
        //           order_position: 3,
        //           product_type: 'Pjate e Pare',
        //           attributes: '',
        //           photo: '/uploads/products/5610/1541683504-Recipe_64.jpg',
        //           photos: [
        //             {
        //               id: 6950,
        //               name: '1541683504-Recipe_64.jpg',
        //               path: 'uploads/products/5610/1541683504-Recipe_64.jpg',
        //               thumbnail_path: 'uploads/products/5610/tn-1541683504-Recipe_64.jpg',
        //               imageable_id: 5610,
        //               imageable_type: 'App\\Product',
        //               created_at: '2018-11-08 14:25:04',
        //               updated_at: '2018-11-08 14:25:04',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 21331,
        //           name: 'Taliatele Mare & Monti',
        //           description: 'Salcë me karkaleca të shuar me konjak dhe verë të bardhë, pana dhe salcë tartufi)',
        //           sale_price: 590,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 50,
        //           order_position: 3,
        //           product_type: 'Pjate e Pare',
        //           attributes: '',
        //           photo: '/uploads/products/21331/1650536486-TALIATELE MARE OK.jpg',
        //           photos: [
        //             {
        //               id: 19603,
        //               name: '1650536486-TALIATELE MARE OK.jpg',
        //               path: 'uploads/products/21331/1650536486-TALIATELE MARE OK.jpg',
        //               thumbnail_path: 'uploads/products/21331/tn-1650536486-TALIATELE MARE OK.jpg',
        //               imageable_id: 21331,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-04-21 12:21:26',
        //               updated_at: '2022-04-21 12:21:26',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 9152,
        //           name: 'Pene pesto pistak salmon',
        //           description: 'Salmon I tiganisur me pistak dhe salcë pesto',
        //           sale_price: 550,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 50,
        //           order_position: 3,
        //           product_type: 'Pjate e Pare',
        //           attributes: '',
        //           photo: '/uploads/products/9152/1649931508-smoked-salmon-and-dill-pesto-pasta-101096-1.jpeg',
        //           photos: [
        //             {
        //               id: 19561,
        //               name: '1649931508-smoked-salmon-and-dill-pesto-pasta-101096-1.jpeg',
        //               path: 'uploads/products/9152/1649931508-smoked-salmon-and-dill-pesto-pasta-101096-1.jpeg',
        //               thumbnail_path:
        //                 'uploads/products/9152/tn-1649931508-smoked-salmon-and-dill-pesto-pasta-101096-1.jpeg',
        //               imageable_id: 9152,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-04-14 12:18:28',
        //               updated_at: '2022-04-14 12:18:29',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 8870,
        //           name: 'Papardele bolognese',
        //           description:
        //             'Pasta te fresketa te pergatitura me mish te grire dhe, salce domate te fresket dhe ereza. [Papardelle bolognese ]',
        //           sale_price: 490,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 50,
        //           order_position: 3,
        //           product_type: 'Pjate e Pare',
        //           attributes: '',
        //           photo: '/uploads/products/8870/1567747745-cropped-1978-pappardelle-alla-bolognese-1000.jpg',
        //           photos: [
        //             {
        //               id: 11812,
        //               name: '1567747745-cropped-1978-pappardelle-alla-bolognese-1000.jpg',
        //               path: 'uploads/products/8870/1567747745-cropped-1978-pappardelle-alla-bolognese-1000.jpg',
        //               thumbnail_path:
        //                 'uploads/products/8870/tn-1567747745-cropped-1978-pappardelle-alla-bolognese-1000.jpg',
        //               imageable_id: 8870,
        //               imageable_type: 'App\\Product',
        //               created_at: '2019-09-06 07:29:05',
        //               updated_at: '2019-09-06 07:29:05',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 6103,
        //           name: 'Spageti aglio olio e tonno',
        //           description: 'Ton i fresket, hudher, ullinj, grana, majdanoz, fara spec djeges.',
        //           sale_price: 450,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 50,
        //           order_position: 3,
        //           product_type: 'Pjate e Pare',
        //           attributes: '',
        //           photo: '/uploads/products/6103/1650539446-aglio olio tono ok.jpg',
        //           photos: [
        //             {
        //               id: 19608,
        //               name: '1650539446-aglio olio tono ok.jpg',
        //               path: 'uploads/products/6103/1650539446-aglio olio tono ok.jpg',
        //               thumbnail_path: 'uploads/products/6103/tn-1650539446-aglio olio tono ok.jpg',
        //               imageable_id: 6103,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-04-21 13:10:46',
        //               updated_at: '2022-04-21 13:10:46',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 21144,
        //           name: 'Tortellini ne Modena',
        //           description:
        //             'tortellini të mbushur me proshutë krudo, mortadella  dhe mish gici, në salcë djathi grana dhe aceto balsamike)',
        //           sale_price: 550,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 50,
        //           order_position: 3,
        //           product_type: 'Pjate e Pare',
        //           attributes: '',
        //           photo: '/uploads/products/21144/1650009150-tortellini ne modena.png',
        //           photos: [
        //             {
        //               id: 19580,
        //               name: '1650009150-tortellini ne modena.png',
        //               path: 'uploads/products/21144/1650009150-tortellini ne modena.png',
        //               thumbnail_path: 'uploads/products/21144/tn-1650009150-tortellini ne modena.png',
        //               imageable_id: 21144,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-04-15 09:52:30',
        //               updated_at: '2022-04-15 09:52:30',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //       ],
        //     },
        //     '23': {
        //       id: 149,
        //       order_position: 3,
        //       product_type: 'Supa / Soups',
        //       products: [
        //         {
        //           id: 21347,
        //           name: 'Supe rosso relativo',
        //           description: 'domate, spec I kuq, patate, të pjekura dhe grira me borzilok',
        //           sale_price: 290,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 149,
        //           order_position: 3,
        //           product_type: 'Supa / Soups',
        //           attributes: '',
        //           photo: '/uploads/products/21347/1650537004-ROSO RELATIVO OK.jpg',
        //           photos: [
        //             {
        //               id: 19606,
        //               name: '1650537004-ROSO RELATIVO OK.jpg',
        //               path: 'uploads/products/21347/1650537004-ROSO RELATIVO OK.jpg',
        //               thumbnail_path: 'uploads/products/21347/tn-1650537004-ROSO RELATIVO OK.jpg',
        //               imageable_id: 21347,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-04-21 12:30:04',
        //               updated_at: '2022-04-21 12:30:04',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 8811,
        //           name: 'Green supe',
        //           description:
        //             'Supe kremoze e pergatitur me spinaq, majdanoz, kungull jeshil dhe patate .(- GREEN SOUP with  SPINACH, PARSLEY, ZUCCHINI and POTATOES)',
        //           sale_price: 290,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 149,
        //           order_position: 3,
        //           product_type: 'Supa / Soups',
        //           attributes: '',
        //           photo: '/uploads/products/8811/1566975141-images (23).jpg',
        //           photos: [
        //             {
        //               id: 11737,
        //               name: '1566975141-images (23).jpg',
        //               path: 'uploads/products/8811/1566975141-images (23).jpg',
        //               thumbnail_path: 'uploads/products/8811/tn-1566975141-images (23).jpg',
        //               imageable_id: 8811,
        //               imageable_type: 'App\\Product',
        //               created_at: '2019-08-28 08:52:21',
        //               updated_at: '2019-08-28 08:52:22',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 6276,
        //           name: 'Supe pule dhe perime',
        //           description: 'Supe kremoze me pulë, kuba karrote, kungulli, bizele',
        //           sale_price: 320,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 149,
        //           order_position: 3,
        //           product_type: 'Supa / Soups',
        //           attributes: '',
        //           photo: '/uploads/products/6276/1544796141-Supe-me-perime-750x500.jpg',
        //           photos: [
        //             {
        //               id: 7773,
        //               name: '1544796141-Supe-me-perime-750x500.jpg',
        //               path: 'uploads/products/6276/1544796141-Supe-me-perime-750x500.jpg',
        //               thumbnail_path: 'uploads/products/6276/tn-1544796141-Supe-me-perime-750x500.jpg',
        //               imageable_id: 6276,
        //               imageable_type: 'App\\Product',
        //               created_at: '2018-12-14 15:02:21',
        //               updated_at: '2018-12-14 15:02:21',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //       ],
        //     },
        //     '35': {
        //       id: 49,
        //       order_position: 4,
        //       product_type: 'Pjate Mishi',
        //       products: [
        //         {
        //           id: 21335,
        //           name: 'Fileto viçi Champignon',
        //           description: 'Fileto viçi në salcë kremoze me piper të zi dhe kërpudha',
        //           sale_price: 1200,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 49,
        //           order_position: 4,
        //           product_type: 'Pjate Mishi',
        //           attributes: '',
        //           photo: '/uploads/products/21335/1650530959-fileto champi.jpg',
        //           photos: [
        //             {
        //               id: 19592,
        //               name: '1650530959-fileto champi.jpg',
        //               path: 'uploads/products/21335/1650530959-fileto champi.jpg',
        //               thumbnail_path: 'uploads/products/21335/tn-1650530959-fileto champi.jpg',
        //               imageable_id: 21335,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-04-21 10:49:19',
        //               updated_at: '2022-04-21 10:49:19',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 21146,
        //           name: 'Biftek vici ne stil Argjentinas',
        //           description:
        //             '(Biftek viçi zgare shoqëruar me patate baby, salcë  majdanozi argjentinase dhe salcë kosi',
        //           sale_price: 680,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 49,
        //           order_position: 4,
        //           product_type: 'Pjate Mishi',
        //           attributes: '',
        //           photo: '/uploads/products/21146/1641893535-biftek argjentinas.jpeg',
        //           photos: [
        //             {
        //               id: 19399,
        //               name: '1641893535-biftek argjentinas.jpeg',
        //               path: 'uploads/products/21146/1641893535-biftek argjentinas.jpeg',
        //               thumbnail_path: 'uploads/products/21146/tn-1641893535-biftek argjentinas.jpeg',
        //               imageable_id: 21146,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-01-11 10:32:15',
        //               updated_at: '2022-01-11 10:32:15',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 21334,
        //           name: 'Fileto viçi Cheffe',
        //           description: '(Fileto viçi zgare shoqëruar me asparag, riso nero,  pure karrote& salce demiglas )',
        //           sale_price: 1300,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 49,
        //           order_position: 4,
        //           product_type: 'Pjate Mishi',
        //           attributes: '',
        //           photo: '/uploads/products/21334/1650535097-FILETO VICI CHEFFE OK.jpg',
        //           photos: [
        //             {
        //               id: 19598,
        //               name: '1650535097-FILETO VICI CHEFFE OK.jpg',
        //               path: 'uploads/products/21334/1650535097-FILETO VICI CHEFFE OK.jpg',
        //               thumbnail_path: 'uploads/products/21334/tn-1650535097-FILETO VICI CHEFFE OK.jpg',
        //               imageable_id: 21334,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-04-21 11:58:17',
        //               updated_at: '2022-04-21 11:58:17',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 21338,
        //           name: 'Fileto pule Genovese',
        //           description: 'Fileto pule shoqëruar me perime të ziera,  pure patate dhe pesto Genovese',
        //           sale_price: 520,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 49,
        //           order_position: 4,
        //           product_type: 'Pjate Mishi',
        //           attributes: '',
        //           photo: '',
        //           photos: [],
        //         },
        //         {
        //           id: 2543,
        //           name: 'Fileto pule Tartufata',
        //           description: 'Fileto pule dhe salce tartufi shoqeruar me oriz dhe kerpudha zgare.',
        //           sale_price: 540,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 49,
        //           order_position: 4,
        //           product_type: 'Pjate Mishi',
        //           attributes: '',
        //           photo: '/uploads/products/2543/1650535793-FILETO TARTUFATA OK.jpg',
        //           photos: [
        //             {
        //               id: 19599,
        //               name: '1650535793-FILETO TARTUFATA OK.jpg',
        //               path: 'uploads/products/2543/1650535793-FILETO TARTUFATA OK.jpg',
        //               thumbnail_path: 'uploads/products/2543/tn-1650535793-FILETO TARTUFATA OK.jpg',
        //               imageable_id: 2543,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-04-21 12:09:53',
        //               updated_at: '2022-04-21 12:09:54',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 21336,
        //           name: 'Kontrafileto gici',
        //           description:
        //             'Bërxollë gici me mollë të pjekur në verë të kuqe të aromatizuar shoqëruar me finok dhe mollë jeshile',
        //           sale_price: 650,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 49,
        //           order_position: 4,
        //           product_type: 'Pjate Mishi',
        //           attributes: '',
        //           photo: '',
        //           photos: [],
        //         },
        //         {
        //           id: 21339,
        //           name: 'Fileto pule stil Cezar',
        //           description:
        //             'Fileto pule shoqëruar me misër, krutona, pomodorini furre dhe  salca jonë e famshme Cezar',
        //           sale_price: 520,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 49,
        //           order_position: 4,
        //           product_type: 'Pjate Mishi',
        //           attributes: '',
        //           photo: '/uploads/products/21339/1650530995-fileto cezar.jpg',
        //           photos: [
        //             {
        //               id: 19593,
        //               name: '1650530995-fileto cezar.jpg',
        //               path: 'uploads/products/21339/1650530995-fileto cezar.jpg',
        //               thumbnail_path: 'uploads/products/21339/tn-1650530995-fileto cezar.jpg',
        //               imageable_id: 21339,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-04-21 10:49:55',
        //               updated_at: '2022-04-21 10:49:55',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //       ],
        //     },
        //     '42': {
        //       id: 112,
        //       order_position: 6,
        //       product_type: 'Peshk - Fish',
        //       products: [
        //         {
        //           id: 21138,
        //           name: 'Fruta Deti ne zgare',
        //           description: null,
        //           sale_price: 800,
        //           product_category_id: 14,
        //           product_category: 'Menu À la carte',
        //           product_type_id: 112,
        //           order_position: 6,
        //           product_type: 'Peshk - Fish',
        //           attributes: '',
        //           photo: '/uploads/products/21138/1641839297-fruta_deti.jpg',
        //           photos: [
        //             {
        //               id: 19385,
        //               name: '1641839297-fruta_deti.jpg',
        //               path: 'uploads/products/21138/1641839297-fruta_deti.jpg',
        //               thumbnail_path: 'uploads/products/21138/tn-1641839297-fruta_deti.jpg',
        //               imageable_id: 21138,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-01-10 19:28:17',
        //               updated_at: '2022-01-10 19:28:17',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 21341,
        //           name: 'Levrek mediterran',
        //           description:
        //             'Fileto levreku në zgarë me pomodorini, ullinj Kalamata,  qepë e kuqe të shuara me verë të bardhë, borzilok',
        //           sale_price: 750,
        //           product_category_id: 14,
        //           product_category: 'Menu À la carte',
        //           product_type_id: 112,
        //           order_position: 6,
        //           product_type: 'Peshk - Fish',
        //           attributes: '',
        //           photo: '',
        //           photos: [],
        //         },
        //         {
        //           id: 21342,
        //           name: 'Oktapod krokant',
        //           description:
        //             'Oktapod I aromatizuar me rozmarinë,  pure patate ëmbël, aceto balsamico  & radikio zgare',
        //           sale_price: 650,
        //           product_category_id: 14,
        //           product_category: 'Menu À la carte',
        //           product_type_id: 112,
        //           order_position: 6,
        //           product_type: 'Peshk - Fish',
        //           attributes: '',
        //           photo: '',
        //           photos: [],
        //         },
        //         {
        //           id: 17675,
        //           name: 'Salmon tropical',
        //           description: 'Salmon dhe ananas me kinoa te marinuar me erza te fresketa.',
        //           sale_price: 950,
        //           product_category_id: 14,
        //           product_category: 'Menu À la carte',
        //           product_type_id: 112,
        //           order_position: 6,
        //           product_type: 'Peshk - Fish',
        //           attributes: '',
        //           photo: '/uploads/products/17675/1608619722-EE1F1F7B-B4C7-4CC3-ACF1-D1747F2D41FB.jpeg',
        //           photos: [
        //             {
        //               id: 17316,
        //               name: '1608619722-EE1F1F7B-B4C7-4CC3-ACF1-D1747F2D41FB.jpeg',
        //               path: 'uploads/products/17675/1608619722-EE1F1F7B-B4C7-4CC3-ACF1-D1747F2D41FB.jpeg',
        //               thumbnail_path: 'uploads/products/17675/tn-1608619722-EE1F1F7B-B4C7-4CC3-ACF1-D1747F2D41FB.jpeg',
        //               imageable_id: 17675,
        //               imageable_type: 'App\\Product',
        //               created_at: '2020-12-22 07:48:42',
        //               updated_at: '2020-12-22 07:48:42',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 2706,
        //           name: 'Antipaste Miks Deti',
        //           description: 'SEAFOOD APPETIZERS (SHRIMPS, BASS FISH, SEAFOOD)',
        //           sale_price: 2000,
        //           product_category_id: 14,
        //           product_category: 'Menu À la carte',
        //           product_type_id: 112,
        //           order_position: 6,
        //           product_type: 'Peshk - Fish',
        //           attributes: '',
        //           photo: '/uploads/products/2706/1569676566-bffd8c93ac0f0de1973eb1f149cc5068.jpg',
        //           photos: [
        //             {
        //               id: 12084,
        //               name: '1569676566-bffd8c93ac0f0de1973eb1f149cc5068.jpg',
        //               path: 'uploads/products/2706/1569676566-bffd8c93ac0f0de1973eb1f149cc5068.jpg',
        //               thumbnail_path: 'uploads/products/2706/tn-1569676566-bffd8c93ac0f0de1973eb1f149cc5068.jpg',
        //               imageable_id: 2706,
        //               imageable_type: 'App\\Product',
        //               created_at: '2019-09-28 15:16:06',
        //               updated_at: '2019-09-28 15:16:07',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //       ],
        //     },
        //     '45': {
        //       id: 51,
        //       order_position: 6,
        //       product_type: 'Side Dish',
        //       products: [
        //         {
        //           id: 2677,
        //           name: 'Tarator me kastravec',
        //           description:
        //             'Kastravec, kos,hudhra,vaj ulliri,kripe, piper, koper (YOGURT with CUCUMBER, OLIVE OIL, PEPPER and GARLIC (on request))',
        //           sale_price: 200,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 51,
        //           order_position: 6,
        //           product_type: 'Side Dish',
        //           attributes: '',
        //           photo: '/uploads/products/2677/1532506112-tostibanaan-tzatziki-1.png',
        //           photos: [
        //             {
        //               id: 1232,
        //               name: '1532506112-tostibanaan-tzatziki-1.png',
        //               path: 'uploads/products/2677/1532506112-tostibanaan-tzatziki-1.png',
        //               thumbnail_path: 'uploads/products/2677/tn-1532506112-tostibanaan-tzatziki-1.png',
        //               imageable_id: 2677,
        //               imageable_type: 'App\\Product',
        //               created_at: '2018-07-25 10:08:32',
        //               updated_at: '2018-07-25 10:08:32',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 17985,
        //           name: 'Homemade Fries',
        //           description: null,
        //           sale_price: 250,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 51,
        //           order_position: 6,
        //           product_type: 'Side Dish',
        //           attributes: '',
        //           photo: '/uploads/products/17985/1596010911-French-Fries-Crisplid-Piping-Pot-Curry-13.jpg',
        //           photos: [
        //             {
        //               id: 16382,
        //               name: '1596010911-French-Fries-Crisplid-Piping-Pot-Curry-13.jpg',
        //               path: 'uploads/products/17985/1596010911-French-Fries-Crisplid-Piping-Pot-Curry-13.jpg',
        //               thumbnail_path:
        //                 'uploads/products/17985/tn-1596010911-French-Fries-Crisplid-Piping-Pot-Curry-13.jpg',
        //               imageable_id: 17985,
        //               imageable_type: 'App\\Product',
        //               created_at: '2020-07-29 10:21:51',
        //               updated_at: '2020-07-29 10:21:51',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 2610,
        //           name: 'Perime zgare / te ziera',
        //           description: null,
        //           sale_price: 250,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 51,
        //           order_position: 6,
        //           product_type: 'Side Dish',
        //           attributes: '',
        //           photo: '/uploads/products/2610/1532505601-grilled-vegetables-767.png',
        //           photos: [
        //             {
        //               id: 1231,
        //               name: '1532505601-grilled-vegetables-767.png',
        //               path: 'uploads/products/2610/1532505601-grilled-vegetables-767.png',
        //               thumbnail_path: 'uploads/products/2610/tn-1532505601-grilled-vegetables-767.png',
        //               imageable_id: 2610,
        //               imageable_type: 'App\\Product',
        //               created_at: '2018-07-25 10:00:01',
        //               updated_at: '2018-07-25 10:00:01',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 2605,
        //           name: 'Patate furre',
        //           description: 'BAKED POTATOES',
        //           sale_price: 200,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 51,
        //           order_position: 6,
        //           product_type: 'Side Dish',
        //           attributes: '',
        //           photo: '/uploads/products/2605/1539846829-1428912649026.jpg',
        //           photos: [
        //             {
        //               id: 6266,
        //               name: '1539846829-1428912649026.jpg',
        //               path: 'uploads/products/2605/1539846829-1428912649026.jpg',
        //               thumbnail_path: 'uploads/products/2605/tn-1539846829-1428912649026.jpg',
        //               imageable_id: 2605,
        //               imageable_type: 'App\\Product',
        //               created_at: '2018-10-18 11:13:49',
        //               updated_at: '2018-10-18 11:13:50',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 2721,
        //           name: 'Pilaf',
        //           description: 'RICE - White & Traditional',
        //           sale_price: 100,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 51,
        //           order_position: 6,
        //           product_type: 'Side Dish',
        //           attributes: '',
        //           photo:
        //             '/uploads/products/2721/1539783591-1033249144001_1727310058001_ari-origin05-arc-168-1341855439964.jpg',
        //           photos: [
        //             {
        //               id: 6215,
        //               name: '1539783591-1033249144001_1727310058001_ari-origin05-arc-168-1341855439964.jpg',
        //               path: 'uploads/products/2721/1539783591-1033249144001_1727310058001_ari-origin05-arc-168-1341855439964.jpg',
        //               thumbnail_path:
        //                 'uploads/products/2721/tn-1539783591-1033249144001_1727310058001_ari-origin05-arc-168-1341855439964.jpg',
        //               imageable_id: 2721,
        //               imageable_type: 'App\\Product',
        //               created_at: '2018-10-17 17:39:51',
        //               updated_at: '2018-10-17 17:39:51',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //       ],
        //     },
        //     '52': {
        //       id: 107,
        //       order_position: 7,
        //       product_type: 'Embelsira - Sallate frutash',
        //       products: [
        //         {
        //           id: 21343,
        //           name: 'Sufle cuore di pistachio',
        //           description: 'Sufle cokollate me zemër krem  pistachio shoqëruar me akullore',
        //           sale_price: 400,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 107,
        //           order_position: 7,
        //           product_type: 'Embelsira - Sallate frutash',
        //           attributes: '',
        //           photo: '/uploads/products/21343/1650533855-SUFLE (3).jpg',
        //           photos: [
        //             {
        //               id: 19594,
        //               name: '1650533855-SUFLE (3).jpg',
        //               path: 'uploads/products/21343/1650533855-SUFLE (3).jpg',
        //               thumbnail_path: 'uploads/products/21343/tn-1650533855-SUFLE (3).jpg',
        //               imageable_id: 21343,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-04-21 11:37:35',
        //               updated_at: '2022-04-21 11:37:35',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 21344,
        //           name: 'Mille Foglie” di Cheesecake',
        //           description: 'Luleshtrydhe, krem chantilly me philadelphia,  fleta milfe, të ndërtuara në gotë qelqi',
        //           sale_price: 350,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 107,
        //           order_position: 7,
        //           product_type: 'Embelsira - Sallate frutash',
        //           attributes: '',
        //           photo: '/uploads/products/21344/1650534959-MILFE OK.jpg',
        //           photos: [
        //             {
        //               id: 19597,
        //               name: '1650534959-MILFE OK.jpg',
        //               path: 'uploads/products/21344/1650534959-MILFE OK.jpg',
        //               thumbnail_path: 'uploads/products/21344/tn-1650534959-MILFE OK.jpg',
        //               imageable_id: 21344,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-04-21 11:55:59',
        //               updated_at: '2022-04-21 11:55:59',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 3485,
        //           name: 'Fantazi Frutash',
        //           description: 'Fruta te stines',
        //           sale_price: 300,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 107,
        //           order_position: 7,
        //           product_type: 'Embelsira - Sallate frutash',
        //           attributes: '',
        //           photo: '/uploads/products/3485/1537700557-download (6).jpeg',
        //           photos: [
        //             {
        //               id: 4543,
        //               name: '1537700557-download (6).jpeg',
        //               path: 'uploads/products/3485/1537700557-download (6).jpeg',
        //               thumbnail_path: 'uploads/products/3485/tn-1537700557-download (6).jpeg',
        //               imageable_id: 3485,
        //               imageable_type: 'App\\Product',
        //               created_at: '2018-09-23 15:02:37',
        //               updated_at: '2018-09-23 15:02:37',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 2681,
        //           name: 'Tiramisu',
        //           description: null,
        //           sale_price: 350,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 107,
        //           order_position: 7,
        //           product_type: 'Embelsira - Sallate frutash',
        //           attributes: '',
        //           photo:
        //             '/uploads/products/2681/1554119759-default_ae4ea1ec6bdc340de223302092dd39c7_dreamstime_s_78520524 (1).jpg',
        //           photos: [
        //             {
        //               id: 9546,
        //               name: '1554119759-default_ae4ea1ec6bdc340de223302092dd39c7_dreamstime_s_78520524 (1).jpg',
        //               path: 'uploads/products/2681/1554119759-default_ae4ea1ec6bdc340de223302092dd39c7_dreamstime_s_78520524 (1).jpg',
        //               thumbnail_path:
        //                 'uploads/products/2681/tn-1554119759-default_ae4ea1ec6bdc340de223302092dd39c7_dreamstime_s_78520524 (1).jpg',
        //               imageable_id: 2681,
        //               imageable_type: 'App\\Product',
        //               created_at: '2019-04-01 13:55:59',
        //               updated_at: '2019-04-01 13:55:59',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 9975,
        //           name: 'Strudel i fresket me molle',
        //           description: 'Strudel i fresket me molle',
        //           sale_price: 250,
        //           product_category_id: 3,
        //           product_category: 'Të freskëta',
        //           product_type_id: 107,
        //           order_position: 7,
        //           product_type: 'Embelsira - Sallate frutash',
        //           attributes: '',
        //           photo: '/uploads/products/9975/1576135636-115F725A-B5EB-48F8-A3A6-6815893F4578.jpeg',
        //           photos: [
        //             {
        //               id: 13308,
        //               name: '1576135636-115F725A-B5EB-48F8-A3A6-6815893F4578.jpeg',
        //               path: 'uploads/products/9975/1576135636-115F725A-B5EB-48F8-A3A6-6815893F4578.jpeg',
        //               thumbnail_path: 'uploads/products/9975/tn-1576135636-115F725A-B5EB-48F8-A3A6-6815893F4578.jpeg',
        //               imageable_id: 9975,
        //               imageable_type: 'App\\Product',
        //               created_at: '2019-12-12 08:27:16',
        //               updated_at: '2019-12-12 08:27:17',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //       ],
        //     },
        //     '55': {
        //       id: 106,
        //       order_position: 7,
        //       product_type: 'Pizza',
        //       products: [
        //         {
        //           id: 20653,
        //           name: 'Pizza / Pinsa proshute kerpudhe',
        //           description: 'Pizza or Pinsa Ham And Mushrooms, with pomodoro, mozzarella, prosciutto cotto, funghi',
        //           sale_price: 600,
        //           product_category_id: 14,
        //           product_category: 'Menu À la carte',
        //           product_type_id: 106,
        //           order_position: 7,
        //           product_type: 'Pizza',
        //           attributes: '',
        //           photo: '/uploads/products/20653/1634132983-prosciuto fungi.jpg',
        //           photos: [
        //             {
        //               id: 19024,
        //               name: '1634132983-prosciuto fungi.jpg',
        //               path: 'uploads/products/20653/1634132983-prosciuto fungi.jpg',
        //               thumbnail_path: 'uploads/products/20653/tn-1634132983-prosciuto fungi.jpg',
        //               imageable_id: 20653,
        //               imageable_type: 'App\\Product',
        //               created_at: '2021-10-13 15:49:43',
        //               updated_at: '2021-10-13 15:49:43',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 20655,
        //           name: 'Pizza / Pinsa Vegetariana',
        //           description:
        //             'Pizza or Pinsa Vegetariana - pomodoro, mozzarella, peperoni, melanzane, fungi, carciofi, zuchine, olive nere, basilico',
        //           sale_price: 550,
        //           product_category_id: 14,
        //           product_category: 'Menu À la carte',
        //           product_type_id: 106,
        //           order_position: 7,
        //           product_type: 'Pizza',
        //           attributes: '',
        //           photo: '/uploads/products/20655/1634133465-vegjetariane.jpg',
        //           photos: [
        //             {
        //               id: 19027,
        //               name: '1634133465-vegjetariane.jpg',
        //               path: 'uploads/products/20655/1634133465-vegjetariane.jpg',
        //               thumbnail_path: 'uploads/products/20655/tn-1634133465-vegjetariane.jpg',
        //               imageable_id: 20655,
        //               imageable_type: 'App\\Product',
        //               created_at: '2021-10-13 15:57:45',
        //               updated_at: '2021-10-13 15:57:45',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 20652,
        //           name: 'Pizza / Pinsa Tartufata',
        //           description: 'Pizza or Pinsa Tartufata me mozzarella, panna, tartufo, fungi (mushrooms)',
        //           sale_price: 600,
        //           product_category_id: 14,
        //           product_category: 'Menu À la carte',
        //           product_type_id: 106,
        //           order_position: 7,
        //           product_type: 'Pizza',
        //           attributes: '',
        //           photo: '/uploads/products/20652/1650008855-pizza tartu.png',
        //           photos: [
        //             {
        //               id: 19576,
        //               name: '1650008855-pizza tartu.png',
        //               path: 'uploads/products/20652/1650008855-pizza tartu.png',
        //               thumbnail_path: 'uploads/products/20652/tn-1650008855-pizza tartu.png',
        //               imageable_id: 20652,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-04-15 09:47:35',
        //               updated_at: '2022-04-15 09:47:35',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 20651,
        //           name: 'Pizza / Pinsa Genovese',
        //           description: 'Pizza or Pinsa Genovese me mozzarella, mortadella, pesto e pistachio',
        //           sale_price: 650,
        //           product_category_id: 14,
        //           product_category: 'Menu À la carte',
        //           product_type_id: 106,
        //           order_position: 7,
        //           product_type: 'Pizza',
        //           attributes: '',
        //           photo: '/uploads/products/20651/1634132729-genovese.jpg',
        //           photos: [
        //             {
        //               id: 19021,
        //               name: '1634132729-genovese.jpg',
        //               path: 'uploads/products/20651/1634132729-genovese.jpg',
        //               thumbnail_path: 'uploads/products/20651/tn-1634132729-genovese.jpg',
        //               imageable_id: 20651,
        //               imageable_type: 'App\\Product',
        //               created_at: '2021-10-13 15:45:29',
        //               updated_at: '2021-10-13 15:45:29',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 20650,
        //           name: 'Pizza / Pinsa Margherita',
        //           description: 'Pizza or Pinsa Margherita me pomodoro, mozzarella, basilico',
        //           sale_price: 450,
        //           product_category_id: 14,
        //           product_category: 'Menu À la carte',
        //           product_type_id: 106,
        //           order_position: 7,
        //           product_type: 'Pizza',
        //           attributes: '',
        //           photo: '/uploads/products/20650/1634133723-margerita (1).jpg',
        //           photos: [
        //             {
        //               id: 19028,
        //               name: '1634133723-margerita (1).jpg',
        //               path: 'uploads/products/20650/1634133723-margerita (1).jpg',
        //               thumbnail_path: 'uploads/products/20650/tn-1634133723-margerita (1).jpg',
        //               imageable_id: 20650,
        //               imageable_type: 'App\\Product',
        //               created_at: '2021-10-13 16:02:03',
        //               updated_at: '2021-10-13 16:02:04',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 20649,
        //           name: 'Pizza / Pinsa Diavola',
        //           description: 'Pizza or Pinsa Diavola me pomodoro, mozzarella e salame picante Napoli',
        //           sale_price: 550,
        //           product_category_id: 14,
        //           product_category: 'Menu À la carte',
        //           product_type_id: 106,
        //           order_position: 7,
        //           product_type: 'Pizza',
        //           attributes: '',
        //           photo: '/uploads/products/20649/1634132589-diavola (1).jpg',
        //           photos: [
        //             {
        //               id: 19019,
        //               name: '1634132589-diavola (1).jpg',
        //               path: 'uploads/products/20649/1634132589-diavola (1).jpg',
        //               thumbnail_path: 'uploads/products/20649/tn-1634132589-diavola (1).jpg',
        //               imageable_id: 20649,
        //               imageable_type: 'App\\Product',
        //               created_at: '2021-10-13 15:43:09',
        //               updated_at: '2021-10-13 15:43:09',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 20648,
        //           name: 'Pizza / Pinsa Vecchia Modena',
        //           description:
        //             'Pizza or Pinsa Vechia Modena me mozzarella, prosciutto crudo, rucola, pomodorini, grana padano e aceto di Modena',
        //           sale_price: 700,
        //           product_category_id: 14,
        //           product_category: 'Menu À la carte',
        //           product_type_id: 106,
        //           order_position: 7,
        //           product_type: 'Pizza',
        //           attributes: '',
        //           photo: '/uploads/products/20648/1650008930-piza vecia mode.png',
        //           photos: [
        //             {
        //               id: 19577,
        //               name: '1650008930-piza vecia mode.png',
        //               path: 'uploads/products/20648/1650008930-piza vecia mode.png',
        //               thumbnail_path: 'uploads/products/20648/tn-1650008930-piza vecia mode.png',
        //               imageable_id: 20648,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-04-15 09:48:50',
        //               updated_at: '2022-04-15 09:48:50',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 20646,
        //           name: 'Pizza / Pinsa Fresh Garden',
        //           description: 'mocarela, pomodorini, avocado, pesto, ullinj,  raidikio,rukola, mocarela qershi',
        //           sale_price: 750,
        //           product_category_id: 14,
        //           product_category: 'Menu À la carte',
        //           product_type_id: 106,
        //           order_position: 7,
        //           product_type: 'Pizza',
        //           attributes: '',
        //           photo: '/uploads/products/20646/1634132674-fresh garden pica.jpg',
        //           photos: [
        //             {
        //               id: 19020,
        //               name: '1634132674-fresh garden pica.jpg',
        //               path: 'uploads/products/20646/1634132674-fresh garden pica.jpg',
        //               thumbnail_path: 'uploads/products/20646/tn-1634132674-fresh garden pica.jpg',
        //               imageable_id: 20646,
        //               imageable_type: 'App\\Product',
        //               created_at: '2021-10-13 15:44:34',
        //               updated_at: '2021-10-13 15:44:34',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 20645,
        //           name: 'Pizza / Pinsa 4 Djathrat',
        //           description: 'Pizza Or Pinsa me mozzarella, gorgonzola, scamorza afumicata, ricota, grana padano',
        //           sale_price: 550,
        //           product_category_id: 14,
        //           product_category: 'Menu À la carte',
        //           product_type_id: 106,
        //           order_position: 7,
        //           product_type: 'Pizza',
        //           attributes: '',
        //           photo: '/uploads/products/20645/1634132454-4 formaggi.jpg',
        //           photos: [
        //             {
        //               id: 19016,
        //               name: '1634132454-4 formaggi.jpg',
        //               path: 'uploads/products/20645/1634132454-4 formaggi.jpg',
        //               thumbnail_path: 'uploads/products/20645/tn-1634132454-4 formaggi.jpg',
        //               imageable_id: 20645,
        //               imageable_type: 'App\\Product',
        //               created_at: '2021-10-13 15:40:54',
        //               updated_at: '2021-10-13 15:40:55',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //         {
        //           id: 20647,
        //           name: 'Pizza / Pinsa Capricciosa',
        //           description:
        //             'Pizza or Pinsa me pomodoro, mozzarella, prosciutto cotto, olive nere, carciofi, fungi, peperoni',
        //           sale_price: 650,
        //           product_category_id: 14,
        //           product_category: 'Menu À la carte',
        //           product_type_id: 106,
        //           order_position: 7,
        //           product_type: 'Pizza',
        //           attributes: '',
        //           photo: '/uploads/products/20647/1634132534-capriciosa.jpg',
        //           photos: [
        //             {
        //               id: 19018,
        //               name: '1634132534-capriciosa.jpg',
        //               path: 'uploads/products/20647/1634132534-capriciosa.jpg',
        //               thumbnail_path: 'uploads/products/20647/tn-1634132534-capriciosa.jpg',
        //               imageable_id: 20647,
        //               imageable_type: 'App\\Product',
        //               created_at: '2021-10-13 15:42:14',
        //               updated_at: '2021-10-13 15:42:15',
        //               sector_ids: null,
        //             },
        //             {
        //               id: 19575,
        //               name: '1650008781-piza capric.png',
        //               path: 'uploads/products/20647/1650008781-piza capric.png',
        //               thumbnail_path: 'uploads/products/20647/tn-1650008781-piza capric.png',
        //               imageable_id: 20647,
        //               imageable_type: 'App\\Product',
        //               created_at: '2022-04-15 09:46:21',
        //               updated_at: '2022-04-15 09:46:21',
        //               sector_ids: null,
        //             },
        //           ],
        //         },
        //       ],
        //     },
        //   },
        //   errors: [],
        //   meta: [],
        // }
        // this.dailyMenu = dymmy.data
        // END OF DUMMY  -----------------------------------------------------------------------
      })
    api()
      .get('alacarte-menu')
      .then((response: any) => {
        this.alacarteMenu = response.data.data
      })
    // if (new Date().getHours() >= 17) {
    //   this.isAfterNoon = true
    //   this.menuTitle = 'Menu À la carte'
    // } else {
    //   this.isAfterNoon = false
    //   this.menuTitle = 'Menuja e ditës'
    // }

    // setInterval(() => {
    //   if (new Date().getHours() >= 17) {
    //     this.isAfterNoon = true
    //     this.menuTitle = 'Menu À la carte'
    //   } else {
    //     this.isAfterNoon = false
    //     this.menuTitle = 'Menuja e ditës'
    //   }
    // }, 60000)
  }
  openDailyMenuDetails(product: Object) {
    this.$modal.show('menu-details')
    eventBus.$emit('daily-menu:details', product)
  }
  openFeedback() {
    window.location.href = '/feedback'
  }
}
